const p = {
  id: 1,
  title: "EXHIBITION",
  subtitle: "EXPO 2020, DUBAI",
  details: {
    fullname:
      "the competition for temporary exhibition of Lodzkie Region Zone in Polish Pavilion at Expo 2020 Dubai, UAE",
    competition: "1st place = realized project",
    "co-authors": "Martyna Piech",
    date: "04-11-2021",
    investor: "Marshal's Office of the Lodzkie Region",
  },
  bigImgs: [
    ["dubai/kolaz.jpg"],
    ["dubai/Dubai_szkic.png"],
    ["dubai/Floorplan.jpg"],
  ],
  splits: [
    {
      imgSm: "dubai/modern.jpg",
      img: "dubai/Modern zone 2.jpg",
    },
    {
      imgSm: "dubai/immersive.jpg",
      img: "dubai/Entrance view.jpg",
    },
    {
      imgSm: "dubai/traditional.jpg",
      img: "dubai/Traditional zone 1.jpg",
    },
  ],
  imgs: [
    [
      {
        title: "Modern zone 1",
        src: "dubai/Modern zone 1.jpg",
      },

      {
        title: "Modern zone 3",
        src: "dubai/Modern zone 3.jpg",
      },
      {
        title: "Traditional zone 2",
        src: "dubai/Traditional zone 2.jpg",
      },
    ],
    [
      {
        src: "dubai/zdj1.jpg",
      },
      {
        src: "dubai/zdj2.jpg",
      },
      {
        src: "dubai/zdj3.jpg",
      },
      {
        src: "dubai/zdj4.jpg",
      },
      {
        src: "dubai/zdj5.jpg",
      },
      {
        src: "dubai/zdj6.jpg",
      },
    ],
  ],
  desc: [
    "The competition was organized by the Marshal's Offce of the Lodz Region and the Lodz University of Technology to select the best exhibition design representing our region on World Expo in Dubai. <u>The conceptual design prepared by us won frst place, thus being transferred to the implementation stage. After the competition, in close cooperation with the Offce, we specifed the design for the executive tender.</u>",
    "The main inspiration for the project was the golden autumn among the felds, referring to the time of the exhibition, distorted by the reversed direction of gravity.",
    "The centre of the composition was designed as an immersive zone with a rectangular shape of four LED screens, on which shots from the Voivodeship were be displayed. Around it, the space was divided into two parts - traditional, related to culture and folklore, and modern, representing the enterprises of the region.",
  ],
};

export default p;
